import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../lib/firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { FaUserCircle } from "react-icons/fa";
import Loader from '../components/Loader';
import '../styles/Wallets.css';

const BuyCoin = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [currentUserRole, setCurrentUserRole] = useState(null);
    const [authLoading, setAuthLoading] = useState(true);
    const [account, setAccount] = useState({
        accountType: '',
        name: '',
        address: '',
        memo: ''
    });
    const [tempValues, setTempValues] = useState({});
    const [editMode, setEditMode] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchCurrentUserRole = async () => {
            const auth = getAuth();
            const currentUser = auth.currentUser;

            if (!currentUser) {
                setCurrentUserRole("unauthenticated");
                setAuthLoading(false);
                return;
            }

            try {
                const currentUserDoc = await getDoc(doc(db, "users", currentUser.uid));
                if (currentUserDoc.exists()) {
                    const role = currentUserDoc.data().role || "user";
                    setCurrentUserRole(role);
                } else {
                    setCurrentUserRole("unknown");
                }
            } catch (error) {
                console.error("Error fetching current user role:", error);
                setCurrentUserRole("error");
            } finally {
                setAuthLoading(false);
            }
        };

        fetchCurrentUserRole();
    }, []);

    useEffect(() => {
        const fetchBuyAccount = async () => {
            try {
                const docRef = doc(db, 'users', 'buy');
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setAccount(data);
                    setTempValues(data);
                }
            } catch (err) {
                console.error("Error fetching buy account:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchBuyAccount();
    }, []);

    const toggleEdit = () => {
        if (editMode) {
            setTempValues(account); // Reset on cancel
        }
        setEditMode(!editMode);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTempValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await updateDoc(doc(db, 'users', 'buy'), tempValues);
            setAccount(tempValues);
            setEditMode(false);
            alert("Buy details updated successfully!");
        } catch (error) {
            console.error("Error updating buy details:", error);
            alert("Failed to update buy details.");
        } finally {
            setSaving(false);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    if (loading || authLoading) return <Loader />;

    if (currentUserRole !== "admin") {
        return (
            <div className="web3-user-not-found">
                <FaUserCircle size={48} />
                <h2>Access Denied</h2>
                <div onClick={handleGoBack} className="route-Links">
                    Go Back
                </div>
            </div>
        );
    }

    return (
        <div className="wallets-container">
            <h2>Manage Buy Crypto Details</h2>
            
            <div className="wallet-box">
                <div className="wallet-top-row">
                    <div className="wallet-right">
                        <div className="wallet-header">
                            <h3>{account.accountType.toUpperCase() || 'CRYPTO DETAILS'}</h3>
                        </div>

                        {editMode ? (
                            <>
                                <label>Account Type (e.g. Bitcoin, USDT)</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    name="accountType"
                                    value={tempValues.accountType}
                                    onChange={handleChange}
                                    placeholder="Account Type"
                                />
                                <label>Name on Account</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    name="name"
                                    value={tempValues.name}
                                    onChange={handleChange}
                                    placeholder="Account Name"
                                />
                                <label>Address / Wallet Address</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    name="address"
                                    value={tempValues.address}
                                    onChange={handleChange}
                                    placeholder="Wallet Address"
                                />
                                <label>Memo (Optional)</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    name="memo"
                                    value={tempValues.memo}
                                    onChange={handleChange}
                                    placeholder="Memo"
                                />
                                <div className="plan-actions">
                                    <button 
                                        className='action-btn trade' 
                                        onClick={handleSave}
                                        disabled={saving}
                                    >
                                        {saving ? "Saving..." : "Save Changes"}
                                    </button>
                                    <button 
                                        className='action-btn withdraw' 
                                        onClick={toggleEdit}
                                        disabled={saving}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="wallet-info"><strong>Account Type:</strong> {account.accountType}</p>
                                <p className="wallet-info"><strong>Name:</strong> {account.name}</p>
                                <p className="wallet-info"><strong>Address:</strong> {account.address}</p>
                                {account.memo && <p className="wallet-info"><strong>Memo:</strong> {account.memo}</p>}
                                <div className="plan-actions">
                                    <button 
                                        onClick={toggleEdit}
                                    >
                                        Edit Details
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuyCoin;